const getOffset = (node) => {
  const parentWindow = node && node.ownerDocument.defaultView || window;
  const parentDocument = node && node.ownerDocument || document;
  const box = node.getBoundingClientRect();
  const docElem = parentDocument.documentElement;
  return {
    left: box.left + (parentWindow.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
    top: box.top + (parentWindow.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
  };
};

export { getOffset };
